import React from 'react';
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Stack,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// Import icons for different modal types
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';

const CustomModal = ({
  open,
  onClose,
  title,
  message,
  type = 'info',
  actions = [],
  showCloseButton = true,
}) => {
  // Modal style configuration
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
      xs: '90%',
      sm: '450px',
      md: '500px'
    },
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
  };

  // Icon configuration based on type
  const iconConfig = {
    success: { 
      icon: CheckCircleIcon, 
      color: 'success.main' 
    },
    error: { 
      icon: ErrorIcon, 
      color: 'error.main' 
    },
    warning: { 
      icon: WarningIcon, 
      color: 'warning.main' 
    },
    info: { 
      icon: InfoIcon, 
      color: 'info.main' 
    },
    confirm: { 
      icon: HelpIcon, 
      color: 'info.main' 
    },
  };

  const IconComponent = iconConfig[type]?.icon || InfoIcon;
  const iconColor = iconConfig[type]?.color || 'info.main';

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={style}>
        {/* Close button */}
        {showCloseButton && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'grey.500',
            }}
          >
            <CloseIcon />
          </IconButton>
        )}

        {/* Icon */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          mb: 2 
        }}>
          <IconComponent 
            sx={{ 
              fontSize: 64,
              color: iconColor
            }} 
          />
        </Box>

        {/* Title */}
        {title && (
          <Typography 
            id="modal-title" 
            variant="h6" 
            component="h2" 
            textAlign="center"
            sx={{ mb: 2 }}
          >
            {title}
          </Typography>
        )}

        {/* Message */}
        <Typography 
          id="modal-description" 
          textAlign="center"
          sx={{ mb: 3 }}
        >
          {message}
        </Typography>

        {/* Action Buttons */}
        <Stack 
          direction="row" 
          spacing={2} 
          justifyContent="center"
          sx={{ mt: 2 }}
        >
          {actions.map((action, index) => (
            <Button
              key={index}
              onClick={action.onClick}
              color={action.color || "primary"}
              variant={action.variant || "contained"}
              sx={{
                px: 3,
                py: 1,
                textTransform: 'none',
              }}
            >
              {action.label}
            </Button>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};

export default CustomModal;
